import { render, staticRenderFns } from "./TenantSelector.vue?vue&type=template&id=203823f0&"
import script from "./TenantSelector.vue?vue&type=script&lang=js&"
export * from "./TenantSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports